import { useContext } from 'react';

import { ReadOnlyContext } from '../components/GlobalLayout/ReadOnlyContext';

export const useReadOnlyContext = () => useContext(ReadOnlyContext);
